import { render } from "./FormatStrikethroughVariant.vue?vue&type=template&id=799728c5"
import script from "./FormatStrikethroughVariant.vue?vue&type=script&lang=js"
export * from "./FormatStrikethroughVariant.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatStrikethroughVariant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "799728c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('799728c5', __exports__)) {
    api.reload('799728c5', __exports__)
  }
  
  module.hot.accept("./FormatStrikethroughVariant.vue?vue&type=template&id=799728c5", () => {
    api.rerender('799728c5', render)
  })

}


export default __exports__